import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faFacebook, faInstagram, faTiktok, faMeta } from "@fortawesome/free-brands-svg-icons";
import YoutubeIcon from "./YoutubeIcon";

/** One place for "which platform is this" glyphs, shared by cards and calendars. */
export const PLATFORM_ICON = {
  linkedin:  { icon: faLinkedin,  color: "#0077b5", label: "LinkedIn" },
  facebook:  { icon: faFacebook,  color: "#1877f2", label: "Facebook" },
  instagram: { icon: faInstagram, color: "#e1306c", label: "Instagram" },
  meta:      { icon: faMeta,      color: "#0081fb", label: "Meta" },
  tiktok:    { icon: faTiktok,    color: "#010101", label: "TikTok" },
  youtube:   { icon: null,        color: "#ff0000", label: "YouTube" },
};

/**
 * Platforms of one schedule. Older rows have an empty list or the legacy
 * single `platform` field; both mean LinkedIn, like the publisher assumes.
 */
export const platformsOfSchedule = (schedule) => {
  const list = Array.isArray(schedule?.platforms) && schedule.platforms.length > 0
    ? schedule.platforms
    : schedule?.platform
    ? [schedule.platform]
    : ["linkedin"];
  return list.filter(Boolean).map((p) => String(p).toLowerCase());
};

/** Distinct platforms a post is scheduled for, in the order they appear. */
export const scheduledPlatformsOf = (post) => {
  const seen = new Set();
  for (const s of post?.schedules ?? []) {
    for (const p of platformsOfSchedule(s)) seen.add(p);
  }
  return [...seen];
};

/**
 * Schedules whose time has passed without a post going out: no posted_at,
 * not marked published. Includes rows the publisher already marked as error.
 * Delegated schedules still waiting for approval are a different problem and
 * are left out here (they have their own badge).
 */
export const missedSchedulesOf = (post, now = new Date()) =>
  (post?.schedules ?? []).filter((s) => {
    if (!s?.scheduled_for || s.posted_at || s.post_status === "published") return false;
    if (s.publish_as && s.approval_status !== "approved") return false;
    const when = new Date(s.scheduled_for);
    return !Number.isNaN(when.getTime()) && when.getTime() < now.getTime();
  });

/** A row of small platform glyphs; renders nothing for an empty list. */
const PlatformIcons = ({ platforms = [], size = 14, title = null, style = {} }) => {
  if (!platforms.length) return null;
  return (
    <span
      title={title ?? platforms.map((p) => PLATFORM_ICON[p]?.label ?? p).join(", ")}
      style={{ display: "inline-flex", alignItems: "center", gap: 6, ...style }}
      aria-label={platforms.join(", ")}
    >
      {platforms.map((p) => {
        const meta = PLATFORM_ICON[p];
        if (!meta) return null;
        return p === "youtube"
          ? <YoutubeIcon key={p} height={size + 2} />
          : <FontAwesomeIcon key={p} icon={meta.icon} style={{ fontSize: size, color: meta.color }} />;
      })}
    </span>
  );
};

export default PlatformIcons;
